<template>
  <div class="container-tab">
    <div class="tab-list">
      <div class="all-menu">
        <slot name="main-menu"></slot>
        <div v-if="showIndexMenu" @click="$router.push('/goodsCategory')">
          全部药品分类
        </div>
      </div>
      <slot name="other-menu"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonTab",
  props: {
    // 默认不展示主菜单名
    showIndexMenu: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="stylus" scoped>
.container-tab
  background #fff
  border-bottom 2px solid #3284dd
  .tab-list
    width 1200px
    margin 0 auto
    display flex
    height 40px
    .all-menu
      width 200px
      background #1880f4
      color #fff
      font-size 16px
      font-weight 400
      line-height 40px
      text-align center
      cursor pointer
</style>
